<template>
  <div class="card" v-show="currentCardId == 'company'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>宛名を入力</h2>
        <p>正式な部署名、名前はフルネームで書きましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div class="edit-form-item">
            <div class="item-name">書類名</div>
            <div class="item-body">
              <el-select v-model="formatData.documentTitle" placeholder="">
                <el-option
                  v-for="item in documentTitleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">会社名</div>
            <div class="item-body">
              <el-input
                placeholder="株式会社Yagish"
                class="input-md"
                title="会社名"
                v-model="formatData.company_name"
              />
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">代表取締役等の部署名</div>
            <div class="item-body">
              <el-input
                placeholder="部署名"
                class="input-md"
                title="代表取締役等の部署名"
                v-model="formatData.staff_department_name"
              />
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">最高執行責任者（代表取締役等）の氏名</div>
            <div class="item-body">
              <el-input
                placeholder="氏名"
                class="input-md"
                title="最高執行責任者（代表取締役等）の氏名"
                v-model="formatData.staff_name"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTaishokutodokeFormatData } from '@/composables/format-edit/useTaishokutodokeFormatData'
import documentTitleOptions from '@/utils/format-edit/taishokutodokeDocumentTitleOptions.json'

defineProps<{
  currentCardId?: string
}>()

const formatData = useTaishokutodokeFormatData()
</script>
